import { render, staticRenderFns } from "./product_edit.vue?vue&type=template&id=22afc03b&scoped=true&"
import script from "./product_edit.vue?vue&type=script&lang=js&"
export * from "./product_edit.vue?vue&type=script&lang=js&"
import style0 from "./product_edit.vue?vue&type=style&index=0&id=22afc03b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afc03b",
  null
  
)

export default component.exports